export enum MSConcernType {
  PreventingRelapses = 'Preventing relapses',
  LongTermDisabilityPrevention = 'Long term disability prevention',
  RiskOfLongTermSideEffects = 'Risk of long term side effects',
  RiskOfShortTermSideEffects = 'Risk of short term side effects',
  RegularMonitoring = 'Regular monitoring',
  FamilyPlanning = 'Family planning',
  Other = 'Other',
}

const MSImportantFactorsInDmtDecision: MSConcernType[] = [  
  MSConcernType.PreventingRelapses,
  MSConcernType.LongTermDisabilityPrevention,  
  MSConcernType.RiskOfLongTermSideEffects,  
  MSConcernType.RiskOfShortTermSideEffects, 
  MSConcernType.RegularMonitoring,  
  MSConcernType.FamilyPlanning,  
  MSConcernType.Other
];


export default MSImportantFactorsInDmtDecision;